"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _TopicChooser = _interopRequireDefault(require("./TopicChooser.scss"));

var _DrupalNugget = _interopRequireDefault(require("../../../../targets/cord_sanofi/DrupalNugget.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _strings = require("../../../../config/strings");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _DateTimeHelper = require("../../../helpers/DateTimeHelper");

var _Topic = _interopRequireDefault(require("./Topic"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var TopicChooser = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(TopicChooser, _Kesi2BasicComponent);

  var _super = _createSuper(TopicChooser);

  function TopicChooser(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, TopicChooser);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeCurrentDay", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(day) {
        var newDay, currentDate;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newDay = day;
                currentDate = new Date();
                currentDate.setDate(currentDate.getDate() - (0, _parseInt2["default"])(newDay));
                _context.next = 5;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_START_DATE, currentDate);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeTopic", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(newTopic, path) {
        var data, oldTopic, oldTopicName, schichtboxData, remainingPauseDays, totalPauseDays, schichtboxDataString, schichtarbeitData, schichtarbeitDataString, currentDay, correctedDay, storedEarlyPushTime, storedLatePushTime, currentDayToSet, totalPauseDaysToSet, storedData, storedTopicData, schichtboxDataToLoad, fokusStuff, schichtarbeitDataToLoad, totalPauseDataToLoad, topicToSet, updateValue;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = {};
                oldTopic = _DataStore["default"].getElementByPathImmediately(path);
                oldTopicName = (oldTopic === null || oldTopic === void 0 ? void 0 : oldTopic.name) || 'nix';

                if (!(oldTopicName === newTopic.topicName)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                schichtboxData = _DataStore["default"].getElementByPathImmediately('public.schichtbox');
                remainingPauseDays = (0, _DateTimeHelper.getRemainingPauseDays)();
                totalPauseDays = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_TOTAL_PAUSE_DAYS) || 0;

                if (totalPauseDays > 0 && remainingPauseDays > 0) {
                  schichtboxData.totalPauseDays = Math.max(totalPauseDays - remainingPauseDays, 0);
                }

                schichtboxData.currentPauseStartDay = 0;
                schichtboxData.currentPauseLength = 0;
                schichtboxDataString = (0, _stringify["default"])(schichtboxData);
                schichtarbeitData = _DataStore["default"].getElementByPathImmediately('public.schichtarbeit');
                schichtarbeitDataString = (0, _stringify["default"])(schichtarbeitData);
                currentDay = (0, _DateTimeHelper.getCurrentDay)();
                correctedDay = (0, _DateTimeHelper.getCorrectedCurrentDay)();
                data["".concat(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_STORAGE, ".").concat(oldTopicName)] = {
                  schichtbox: schichtboxDataString,
                  schichtarbeit: schichtarbeitDataString,
                  currentDay: currentDay,
                  correctedDay: correctedDay
                };
                _context2.next = 19;
                return _DataStore["default"].setData(data);

              case 19:
                storedEarlyPushTime = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_EARLY_PUSH_TIME);
                storedLatePushTime = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_LATE_PUSH_TIME);
                currentDayToSet = 0;
                totalPauseDaysToSet = 0;
                storedData = JSON.parse((0, _stringify["default"])(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_STORAGE)));

                if (!(storedData && storedData[newTopic.topicName])) {
                  _context2.next = 51;
                  break;
                }

                storedTopicData = storedData[newTopic.topicName];
                schichtboxDataToLoad = storedTopicData.schichtbox ? JSON.parse(storedTopicData.schichtbox) : {};
                fokusStuff = schichtboxDataToLoad.fokus || {};
                schichtarbeitDataToLoad = storedTopicData.schichtarbeit ? JSON.parse(storedTopicData.schichtarbeit) : {};
                totalPauseDataToLoad = schichtboxDataToLoad.totalPauseDays || 0; // data['public.schichtbox'] = schichtboxDataToLoad
                // data['public.schichtarbeit'] = schichtarbeitDataToLoad
                // data[DATA_STORE_PATHS.SCHICHTBOX_TOTAL_PAUSE_DAYS] = totalPauseDataToLoad || 0
                // data[DATA_STORE_PATHS.SCHICHTBOX_CURRENT_PAUSE_LENGTH] = 0
                // data[DATA_STORE_PATHS.SCHICHTBOX_CURRENT_PAUSE_START_DAY] = 0
                // data[DATA_STORE_PATHS.SCHICHTBOX_EARLY_PUSH_TIME] = storedEarlyPushTime
                // data[DATA_STORE_PATHS.SCHICHTBOX_LATE_PUSH_TIME] = storedLatePushTime

                _context2.next = 32;
                return _DataStore["default"].setSingleData('public.schichtbox.fokus', JSON.parse((0, _stringify["default"])(fokusStuff)));

              case 32:
                _context2.next = 34;
                return _DataStore["default"].setSingleData('public.schichtbarbeit', JSON.parse((0, _stringify["default"])(schichtarbeitDataToLoad)));

              case 34:
                _context2.next = 36;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_TOTAL_PAUSE_DAYS, totalPauseDataToLoad || 0);

              case 36:
                _context2.next = 38;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_CURRENT_PAUSE_LENGTH, 0);

              case 38:
                _context2.next = 40;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_CURRENT_PAUSE_START_DAY, 0);

              case 40:
                _context2.next = 42;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_EARLY_PUSH_TIME, storedEarlyPushTime);

              case 42:
                _context2.next = 44;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_LATE_PUSH_TIME, storedLatePushTime);

              case 44:
                _context2.next = 46;
                return _this.changeCurrentDay(storedTopicData.currentDay ? storedTopicData.currentDay : 0);

              case 46:
                currentDayToSet = storedTopicData.currentDay;
                totalPauseDaysToSet = totalPauseDataToLoad;
                data[_DataStore.DATA_STORE_PATHS.SCHICHTBOX_TOTAL_PAUSE_DAYS] = totalPauseDataToLoad;
                _context2.next = 60;
                break;

              case 51:
                _context2.next = 53;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_TOTAL_PAUSE_DAYS, 0);

              case 53:
                _context2.next = 55;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_CURRENT_PAUSE_LENGTH, 0);

              case 55:
                _context2.next = 57;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_CURRENT_PAUSE_START_DAY, 0);

              case 57:
                totalPauseDaysToSet = 0;
                _context2.next = 60;
                return _this.changeCurrentDay(0);

              case 60:
                if (!(remainingPauseDays > 0)) {
                  _context2.next = 63;
                  break;
                }

                _context2.next = 63;
                return (0, _DateTimeHelper.setPause)(remainingPauseDays, currentDayToSet, totalPauseDaysToSet);

              case 63:
                topicToSet = {
                  name: newTopic.topicName,
                  text: newTopic.topicText,
                  imgPath: newTopic.topicImage,
                  uuid: newTopic.uuid
                };
                _context2.next = 66;
                return _DataStore["default"].setSingleData(path, topicToSet);

              case 66:
                updateValue = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE) || 0;
                _context2.next = 69;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, updateValue + 1);

              case 69:
                _this.setState({
                  topic: topicToSet
                });

              case 70:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    _this.state = {
      topic: null
    };
    return _this;
  }

  (0, _createClass2["default"])(TopicChooser, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nugget = _KESI2Helper["default"].getLikertResult();

      if (nugget && nugget.dataStorePath) {
        var currentTopic = _DataStore["default"].getElementByPathImmediately(nugget.dataStorePath);

        this.setState({
          topic: currentTopic
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var nugget = _KESI2Helper["default"].getLikertResult();

      var storedData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_STORAGE);

      if (nugget) {
        var path = nugget.dataStorePath;
        var topics = nugget.topics;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _TopicChooser["default"].container
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _TopicChooser["default"].innerContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _TopicChooser["default"].wrapper
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _TopicChooser["default"].headline
        }, "Mein Ziel"), /*#__PURE__*/_react["default"].createElement("div", {
          className: _TopicChooser["default"].infotext
        }, "Hier kannst du ausw\xE4hlen, an welchem Themengebiet Du arbeiten m\xF6chtest. Du kannst jederzeit wechseln, aber die besten Resultate erreichst Du, wenn Du 14 Tage bei einem Thema bleibst."), /*#__PURE__*/_react["default"].createElement("div", null, (0, _keys["default"])(topics).length > 0 && topics.map(function (topic) {
          if (!topic) {
            return null;
          }

          var currentDay;

          if (_this2.state.topic && _this2.state.topic.name === topic.topicName) {
            currentDay = (0, _DateTimeHelper.getCorrectedCurrentDay)();
          } else {
            var _storedData$topic$top;

            currentDay = storedData && storedData.hasOwnProperty(topic === null || topic === void 0 ? void 0 : topic.topicName) && ((_storedData$topic$top = storedData[topic.topicName]) === null || _storedData$topic$top === void 0 ? void 0 : _storedData$topic$top.correctedDay);
          }

          return /*#__PURE__*/_react["default"].createElement(_Topic["default"], {
            key: topic.topicName,
            isActive: _this2.state.topic && _this2.state.topic.name === topic.topicName,
            topic: topic,
            path: path,
            changeTopic: _this2.changeTopic,
            day: currentDay
          });
        })))));
      }
    }
  }]);
  return TopicChooser;
}(_KESI2BasicComponent["default"]);

exports["default"] = TopicChooser;
TopicChooser.propTypes = {};
TopicChooser.defaultProps = {};